import _ from "lodash";

import CsrfUtil from "../../util/CsrfUtil";

const httpExceptionInterceptor = function ($injector, $q, $cookies, $rootScope, $window) {
    const stateLocation = {
        503: {
            "0000": "genericError",
            "error.default": "genericError"
        },
        500: {
            "0000": "genericError",
            "error.default": "genericError"
        },
        400: {
            "0000": "genericError",
            "error.default": "genericError",
            notAccountBased: "notAccountBased"
        },
        403: {
            noSession: "loginSessionError",
            "error.default": "genericError",
            44403: "accessDeniedError",
            44404: "csrfAccessDeniedError",
            duplicateSets: "moneySourcesVary",
            "error.pae_inadequate_access": "accessDeniedError",
            transferRestriction: "transferRestrictionError"
        },
        401: {
            "error.pae_inadequate_access": "accessDeniedError",
            44401: "loginSessionError"
        }
    };

    return {
        // Request with errors interception
        requestError: function (rejection) {
            // do something on error
            return $q.reject(rejection);
        },

        response: function (response) {
            const accessToken = response.headers("site_tok");

            if (accessToken !== null && accessToken !== undefined) {
                // this cookie is create for local envionment use only as it
                // is not http only and not secure
                document.cookie =
                    "site_tok=" + response.headers("site_tok") + "; path=/participant";
            }

            return response;
        },

        request: function (config) {
            // do something on error
            if (config.headers["Authorization"] === null) {
                const site_tok_cookie = $cookies.get("site_tok");
                if (site_tok_cookie) {
                    config.headers["site_tok"] = site_tok_cookie;
                }
            }

            const token = $cookies.get("X-CSRF-TOKEN");
            return CsrfUtil.handleRequest(token, config, true);
        },

        // Response with errors interception
        responseError: function (rejection) {
            console.log("responseError args", arguments);
            if (
                (rejection.status === 400 || rejection.status === 500) &&
                rejection.config.url.indexOf(
                    "/participant-web-services/rest/distribution/getAdvisor"
                ) > -1
            ) {
                return $q.reject(rejection);
            }
            if (
                rejection.status === 400 &&
                rejection.config.url.indexOf(
                    "/participant-web-services/rest/distribution/quoteRequest"
                ) > -1
            ) {
                return $q.reject(rejection);
            }
            if (
                rejection.status === 400 &&
                rejection.config.url.indexOf(
                    "/participant-web-services/rest/withdrawal/createDisbursementRequest"
                ) > -1
            ) {
                return $q.reject(rejection);
            }
            if (
                rejection.status === 500 &&
                rejection.config.url.indexOf(
                    "/participant-web-services/rest/distribution/submitDistribution"
                ) > -1
            ) {
                return $q.reject(rejection);
            }
            if (
                rejection.status === 403 &&
                rejection.config.url.indexOf(
                    "/participant-web-services/rest/distribution/submitDistribution"
                ) > -1
            ) {
                return $q.reject(rejection);
            }

            // If the status is 0 and a participant rest call then forward
            // to generic error page
            if (
                rejection.status === 0 &&
                rejection.config.url.indexOf("/participant-web-services/rest") > -1
            ) {
                $injector
                    .get(
                        "$state",
                        {},
                        {
                            reload: false
                        }
                    )
                    .go("genericError");
                return $q.reject("genericError");
            }
            if (
                rejection.status === 400 &&
                rejection.config.url.indexOf(
                    "/participant-web-services/rest/partBankAccount/addBankAccount"
                ) > -1
            ) {
                return $q.reject(rejection);
            }

            if (
                rejection.status != 200 &&
                rejection.config.url.indexOf(
                    "/participant-web-services/rest/partBankAccount/reverifyBankAccount"
                ) > -1
            ) {
                return $q.reject(rejection);
            }

            if (
                rejection.status != 200 &&
                rejection.config.url.indexOf(
                    "/participant-web-services/rest/distribution/getAccountSummary"
                ) > -1
            ) {
                return $q.reject(rejection);
            }

            if (
                rejection.status != 200 &&
                rejection.config.url.indexOf(
                    "/participant-web-services/rest/participantServices/isisRefValues"
                ) > -1 &&
                rejection.config.url.indexOf("rvDomain=CUTOFF_ONE_TIME_LOAN_PAYMENT") > -1
            ) {
                return $q.reject(rejection);
            }

            const status = rejection.status;
            const errorCode = _.get(rejection, "data.error.code");
            const errorDetails = _.get(rejection, "data.error.errors");
            let code = null;

            if (errorDetails) {
                code = errorDetails[0].pinAuthCode;
            } else {
                code = errorCode;
            }

            const state = getState(status, errorCode);

            if (state !== null && state !== undefined) {
                return $injector
                    .get(
                        "$state",
                        {},
                        {
                            reload: false
                        }
                    )
                    .go(state, {
                        errorCode: errorCode
                    });

                return $q.reject(errorCode);
            }

            return $q.reject(rejection);
        }
    }; // End of return

    // End of interceptor function

    // The the location path for a given error code

    // Returns the location state for the given http status and error code
    function getState(httpStatus, errorCode) {
        let state = null;
        const states = stateLocation[httpStatus];

        if (errorCode === undefined || errorCode === null) {
            errorCode = "error.default";
        }

        if (states !== undefined) {
            state = states[errorCode];
        }

        return state;
    }

    function isRunningLocally(url) {
        const isLocalHost = url.indexOf("127.0.0.1") > -1 || url.indexOf("localhost") > -1;
        const isBaseUrlEmpty = url === "";
        return isLocalHost || !isBaseUrlEmpty;
    }
};

httpExceptionInterceptor.$inject = ["$injector", "$q", "$cookies", "$rootScope", "$window"];
export default httpExceptionInterceptor;
